export const services = [
  {
    id: 1,
    slug: 'renovation-interieure',
    name: 'Rénovation Intérieure Complète',
    shortDesc: 'Transformez entièrement votre intérieur avec notre équipe d\'experts. Du sol au plafond, nous gérons tout.',
    fullDesc: 'La rénovation intérieure complète est notre spécialité phare. Nous prenons en charge l\'intégralité de votre projet, de la conception jusqu\'à la livraison clés en main. Notre équipe d\'artisans qualifiés intervient sur tous les corps de métier : plâtrerie, peinture, carrelage, parquet, électricité, plomberie et menuiserie. Chaque chantier est suivi par un conducteur de travaux dédié qui coordonne les équipes et vous informe de l\'avancement.',
    icon: '🏠',
    image: 'https://images.unsplash.com/photo-1589939705384-5185137a7f0f?w=800&q=80',
    price: '15 000',
    duration: '4 à 12 semaines',
    tags: ['Clés en main', 'Devis gratuit', 'Garantie décennale'],
    features: [
      'Gestion complète du chantier par un conducteur de travaux',
      'Tous corps de métier coordonnés (plâtrerie, peinture, carrelage, électricité)',
      'Matériaux de qualité sélectionnés avec soin',
      'Respect des délais et du budget contractualisé',
      'Nettoyage complet et livraison clés en main',
    ],
    category: 'residential',
  },
  {
    id: 2,
    slug: 'cuisine',
    name: 'Rénovation de Cuisine',
    shortDesc: 'Créez la cuisine de vos rêves avec nos designers et artisans. Conception 3D, aménagement et pose complète.',
    fullDesc: 'La cuisine est le cœur de votre maison. Notre équipe spécialisée vous accompagne de la conception à la réalisation, en passant par la sélection des matériaux et des équipements. Nous travaillons avec les meilleures marques du marché pour vous garantir durabilité et esthétique. Notre processus comprend une visite de mesure gratuite, une simulation 3D de votre future cuisine, puis la réalisation par nos menuisiers et installateurs certifiés.',
    icon: '🍳',
    image: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&q=80',
    price: '8 000',
    duration: '2 à 4 semaines',
    tags: ['Conception 3D', 'Électroménager', 'Installation complète'],
    features: [
      'Conception 3D personnalisée et gratuite',
      'Fabrication sur mesure ou pose de cuisines équipées',
      'Gestion complète : plomberie, électricité, carrelage',
      'Conseils en ergonomie et optimisation de l\'espace',
      'SAV et garantie fabricant sur tous les équipements',
    ],
    category: 'residential',
  },
  {
    id: 3,
    slug: 'salle-de-bain',
    name: 'Rénovation de Salle de Bain',
    shortDesc: 'Transformez votre salle de bain en espace bien-être. Douche à l\'italienne, baignoire balnéo, double vasque.',
    fullDesc: 'Une salle de bain rénovée apporte confort, fonctionnalité et valeur ajoutée à votre bien. Nous réalisons des salles de bain sur mesure, adaptées à votre style de vie et à vos goûts. Notre équipe gère l\'ensemble du chantier : dépose de l\'ancien, rénovation de la plomberie et de l\'électricité, pose du carrelage et faïence, installation de la robinetterie, de la douche ou baignoire, et des meubles vasques.',
    icon: '🚿',
    image: 'https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=800&q=80',
    price: '5 000',
    duration: '1 à 3 semaines',
    tags: ['PMR possible', 'Douche italienne', 'Économies d\'eau'],
    features: [
      'Conception personnalisée adaptée à votre surface',
      'Pose de douche à l\'italienne, baignoire ou les deux',
      'Plomberie et électricité aux normes NF C 15-100',
      'Carrelage grand format et faïence décoratives',
      'Accessoires et robinetterie haut de gamme',
    ],
    category: 'residential',
  },
  {
    id: 4,
    slug: 'isolation',
    name: 'Isolation Thermique & Phonique',
    shortDesc: 'Réduisez vos factures d\'énergie jusqu\'à 40% avec nos solutions d\'isolation performantes.',
    fullDesc: 'L\'isolation est l\'investissement le plus rentable pour votre logement : elle réduit vos factures d\'énergie, améliore votre confort thermique et phonique, et augmente la valeur de votre bien. Nous réalisons un bilan thermique complet pour identifier les déperditions et vous proposer la solution la plus adaptée.',
    icon: '🌡️',
    image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800&q=80',
    price: '2 500',
    duration: '1 à 5 jours',
    tags: [/* 'RGE certifié', 'MaPrimeRénov\'', */ 'Économies garanties', 'Confort thermique', 'Valorisation bien'],
    features: [
      'Bilan thermique gratuit de votre logement',
      'TVA réduite à 5,5 % sur les travaux d\'amélioration énergétique',
      'Isolation combles, murs, planchers et fenêtres',
      'Matériaux certifiés (laine de verre, ouate de cellulose, PIR)',
      'Rapport de conformité remis en fin de chantier',
    ],
    category: 'residential',
  },
  {
    id: 5,
    slug: 'toiture',
    name: 'Réfection de Toiture',
    shortDesc: 'Votre toiture est votre première protection. Réfection complète, zinguerie, isolation de combles.',
    fullDesc: 'La toiture est l\'élément le plus critique de votre maison. Notre équipe de couvreurs qualifiés intervient pour la réfection partielle ou totale de votre toiture, quelle que soit sa configuration. Nous travaillons sur tous types de couvertures : tuiles canal ou mécaniques, ardoises naturelles ou synthétiques, zinc, bac acier. Nous intervenons également sur la zinguerie, l\'étanchéité des terrasses, et l\'isolation par le dessus en combles aménagés.',
    icon: '🏗️',
    image: 'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=800&q=80',
    price: '4 000',
    duration: '1 à 3 semaines',
    tags: ['Tous types', 'Zinguerie', 'Garantie 10 ans'],
    features: [
      'Diagnostic complet de l\'état de votre toiture',
      'Réfection totale ou partielle : tuiles, ardoises, zinc',
      'Zinguerie complète : gouttières, chéneaux, solins',
      'Isolation des combles par l\'extérieur (sarking)',
      'Garantie décennale sur tous les travaux de couverture',
    ],
    category: 'residential',
  },
  {
    id: 6,
    slug: 'facade',
    name: 'Ravalement de Façade',
    shortDesc: 'Redonnez un coup de jeune à votre façade et protégez votre bien. Enduits, peinture, ITE.',
    fullDesc: 'Le ravalement de façade est bien plus qu\'une opération esthétique : c\'est une protection essentielle pour votre bâtiment contre les intempéries, l\'humidité et la dégradation. Nous réalisons tous types de ravalements : nettoyage haute pression, réparation des fissures et joints, application d\'enduits hydrauliques ou à la chaux, peinture façade, et isolation thermique par l\'extérieur (ITE).',
    icon: '🎨',
    image: 'https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=800&q=80',
    price: '3 500',
    duration: '1 à 4 semaines',
    tags: ['Enduits', 'ITE possible', 'Peinture façade'],
    features: [
      'Diagnostic et nettoyage haute pression de la façade',
      'Réparation des fissures et reprises d\'enduits',
      'Application d\'enduits hydrauliques, à la chaux ou silicone',
      'Option ITE : isolation thermique par l\'extérieur',
      'Respect des règles d\'urbanisme et des couleurs locales',
    ],
    category: 'residential',
  },
  {
    id: 7,
    slug: 'petits-travaux',
    name: 'Petits travaux',
    shortDesc: 'Fuites, montage de meubles, petites réparations : on s\'occupe de tout, sans minimum de chantier.',
    fullDesc: 'Vous avez une fuite sous l\'évier, une porte qui grince, des meubles IKEA à monter ou une prise à déplacer ? Notre équipe intervient pour tous les petits travaux du quotidien, sans qu\'il soit nécessaire de lancer un grand chantier. Intervention rapide, tarif transparent, pas de mauvaise surprise.',
    icon: '🔧',
    image: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=800&q=80',
    price: '80',
    duration: '1h à 1 journée',
    tags: ['Intervention rapide', 'Sans minimum', 'Tarif horaire'],
    features: [
      'Plomberie courante : fuites, robinetterie, siphons',
      'Montage et installation de meubles (IKEA, sur mesure…)',
      'Petites réparations électriques : prises, interrupteurs, luminaires',
      'Fixations et accrochages : miroirs, tableaux, étagères, TV murale',
      'Joints de salle de bain, silicone, calfeutrement',
    ],
    category: 'residential',
  },
  {
    id: 8,
    slug: 'amenagement-bureau',
    name: 'Aménagement de Bureau',
    shortDesc: 'Optimisez vos espaces de travail pour améliorer la productivité et le bien-être de vos équipes.',
    fullDesc: 'Un environnement de travail bien conçu favorise la productivité, la créativité et le bien-être des collaborateurs. Nous concevons et réalisons des espaces de bureau sur mesure : open spaces modulables, salles de réunion acoustiques, espaces détente, accueil et show-room. Nous assurons la coordination des différents corps de métier pour un résultat professionnel livré dans les délais.',
    icon: '💼',
    image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&q=80',
    price: '10 000',
    duration: '3 à 8 semaines',
    tags: ['ERP conforme', 'Acoustique', 'Identité visuelle'],
    features: [
      'Conception sur mesure avec simulation 3D de l\'espace',
      'Cloisons modulables et verrières design',
      'Acoustique optimisée pour les open spaces et salles de réunion',
      'Électricité tertiaire, réseau informatique et domotique',
      'Travaux en site occupé possibles (week-ends, nuits)',
    ],
    category: 'commercial',
  },
  {
    id: 9,
    slug: 'renovation-commerciale',
    name: 'Rénovation Commerciale',
    shortDesc: 'Rénovez votre commerce, restaurant ou hôtel pour attirer et fidéliser vos clients.',
    fullDesc: 'L\'attractivité de votre local commercial est un facteur clé de succès. Que vous souhaitiez rafraîchir votre devanture, revoir entièrement l\'aménagement intérieur de votre boutique, rénover votre restaurant ou moderniser votre hôtel, nous sommes votre partenaire de confiance. Nous maîtrisons les contraintes spécifiques des établissements recevant du public (ERP) et intervenons en minimisant l\'impact sur votre activité.',
    icon: '🏪',
    image: 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=800&q=80',
    price: '12 000',
    duration: '4 à 16 semaines',
    tags: ['ERP', 'PMR', 'Travaux en phases'],
    features: [
      'Audit de conformité ERP (accessibilité, sécurité incendie)',
      'Conception d\'aménagement commercial avec architecte partenaire',
      'Devanture, vitrine et signalétique intégrées',
      'Organisation en phases pour maintenir votre activité',
      'Dossier de fin de travaux et conformité aux normes ERP',
    ],
    category: 'commercial',
  },
];

export const getServiceBySlug = (slug) => services.find((s) => s.slug === slug);
export const getResidentialServices = () => services.filter((s) => s.category === 'residential');
export const getCommercialServices = () => services.filter((s) => s.category === 'commercial');

export default services;
